import * as React from "react";
import "./App.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import configureStore from "./store/ConfigureStore";
import Routes from "./router/Router";
import Theme from "./theme/Theme";
import axios from "axios";
import { logOut } from "./store/login/action";
import { GetprofileDriverStylingApi } from "./store/profile/action";

const { store, persistor, UserParams } = configureStore();
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      // store.dispatch(logOut());
      //store.dispatch(GetprofileDriverStylingApi(UserParams?.customer));
    }
    return Promise.reject(error);
  }
);
const App = (props) => {
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <React.Suspense fallback={<div>Loading...</div>}>
            <Theme>
              <Routes />
            </Theme>
          </React.Suspense>
        </PersistGate>
      </Provider>
    </>
  );
};

export default App;
